var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.333 1333.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-787.08 500h1000V-500h-1000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-311.217-201.491H62.325V172.05h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-281.312-91.605H92.23v373.542h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-150.702-164.055H222.84v373.542h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-122.763-127.196H250.78v373.542h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-145.6-6.405h373.542v373.542H-145.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-178.127-82.828h373.542v373.542h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.807-241.465h373.542v373.542H-87.807Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-128.105-246.088h373.542v373.542h-373.542Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-69.583-229.357h373.542v373.542H-69.583Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-132.739-276.71h373.542V96.834h-373.542Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-158.55-128.53-287.079-287.079-287.079-158.55 0-287.08 128.529-287.08 287.079s128.53 287.079 287.08 287.079S0 158.55 0 0",
    clipPath: "url(#a)",
    style: {
      fill: "#e0a800",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#002566",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 1049.44 666.667)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-22.443 1270.835 -1126.31)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2367px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-13.97 1840.755 -2139.348)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2366px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-5.279 4320.778 -6486.516)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2366px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "L")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(4.057 -4826.882 9503.048)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2363px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(13.931 -1153.565 3106.686)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2362px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "S")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(20.683 -665.346 2280.439)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2366px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(24.651 -499.759 1983.863)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "58.2363px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(70.69 -375.986 606.563)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "C")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(64.447 -474.1 675.412)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(58.916 -562.374 725.337)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9998px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(51.014 -728.02 828.3)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(45.406 -885.706 939.594)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(39.693 -1072.735 1043.044)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(31.1 -1495.333 1310.725)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "P")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(22.795 -2195.31 1749.993)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(14.45 -3694.107 2689.843)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "X")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(8.552 -6510.364 4544.028)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(3.066 -18788.246 12199.97)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "F")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-4.397 13683.902 -8252.864)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "L")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-9.903 6248.975 -3638.756)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "I")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-16.494 3880.214 -2050.918)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "G")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-25.869 2576.046 -1240.73)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "H")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-34.15 2011.43 -894.959)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9999px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-39.64 1759.152 -756.39)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0001px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-45.117 1576.795 -621.847)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "T")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-53 1372.039 -490.602)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 53,
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "E")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-61.607 1204.872 -383.396)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "53.0002px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "rotate(-71.315 1061.864 -289.518)scale(1.33333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "52.9997px",
      fontFamily: "Helvetica-Bold",
      writingMode: "lr-tb",
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, "M")), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.804 4.564 11.738 11.142 10.049 17.573-1.434 5.456-13.666 9.138-17.505 14.124-3.202 4.16-4.606 12.888-8.314 15.154-4.319 2.641-11.722 2.612-16.681 4.747-8.64 3.721-10.933 11.676-22.221 10.985-6.265-.383-9.218-3.473-14.327-6.079-3.896-1.987-7.507-2.328-10.928-5.909-7.235-7.572-5.801-23.812-1.359-32.526 7.198-14.122 21.005-6.254 31.449-13.959 8.338-6.151 7.046-23.758 6.692-33.151-.036-.98-.366-1.834-.537-2.771l17.275-7.089c4.299 9.826 16.066 11.35 19.316 21.763C-4.581-9.096-5.909-7.089 0 0m-204.396 53.889c-9.605-5.442-21.019-.623-23.954 9.991-.825.58-3.054-.67-4.352-.813-5.065-.558-8.153 1.679-12.257 4.095-3.828-2.698-6.221-7.903-11.745-8.192-3.193-.168-4.955 2.812-6.108-1.498-.982-3.671-.207-9.319-.204-13.022.001-1.869-.912-3.719-.55-5.597.356-1.85 3.125-3.042 4.299-4.381 3.388-3.864.844-6.232.339-10.526-.488-4.147-.47-8.286-1.226-12.506-.643-3.585-2.813-6.586-1.326-10.308 2.641-6.615 6.273.677 10.028 1.136 1.461.179 3.317-.489 4.71-.929.895 1.222-3.913 5.664.337 8.114 4.254 2.452 7.241-6.521 6.817-9.637 4.16.036 8.724-1.647 12.194-3.879 2.287-1.471 9.003-7.843 9.621-10.275.244-.959.112-1.969.114-2.944l1.013-.252c.71 3.871 4.831 5.085 6.513 8.033 1.86 3.26 1.477 7.53 3.093 11.193 2.084 4.727 6.226 8.271 8.287 13.651.56 1.458.644 6.504 3.196 5.842 3.597-2.819 1.712-8.627.03-12.128-1.613-3.357-4.713-6.315-6.053-9.764-1.859-4.784-.677-8.599-4.12-13.226-1.045-1.404-2.674-2.511-3.794-3.859-2.1-2.528-4.319-7.854-8.84-7.241-3.818.518-3.172 4.068-4.078 6.565-3.933 10.835-16.812 14.205-27.123 13.715-5.681-.27-4.022-10.64-2.056-10.654 3.61 3.86 18.415 3.026 20.401-1.63 3.295-7.723-9.569-1.678-11.728-1.527-5.264.368-4.51-1.907-3.051-6.114.366-1.056 1.414-1.804 1.677-2.914 2.259-9.544-2.304-14.588 5.571-23.476.304-.342-.028-.983 1.166-.649-.895 1.76.038 7.473 2.011 7.961 3.608.598 3.417-5.081 4.252-7.57.811-2.414 3.709-6.573 6.356-6.964 1.498-.222 5.341 3.045 6.258 4.274 2.806 3.757 3.725 13.382 8.93 3.325 3.418 3.165 4.868 6.139 4.279 10.903-.219 1.767-1.491 3.799-1.503 5.153-.032 3.602 3.468 3.513 5.409 1.303l2.777-6.141c2.907 4.449 6.263 9.878 5.576 15.515-.199 1.635-2.62 6.589-1.012 7.729 2.715 1.925 6.773-4.518 6.672-6.922.644-.627 2.104 1.829 2.457 2.387 4.637 7.332 2.012 22.099-1.065 29.877-.586 1.483-2.208 1.86-1.903 4.169.713 5.406 5.154 2.941 7.782 3.444 3.559.683 6.219 7.88 6.858 11.039 1.247 6.166 2.376 19.808-6.263 20.994-9.194 1.262-7.399-9.349-14.88-10.562-9.23-1.496-13.085 8.273-9.832 15.692m50.004-19.399c5.13 1.639 6.745 8.078 6.135 13.034-.609 4.941-5.901 6.937-6.544 9.789-.665 2.952 1.125 8.129.91 11.619-.45 7.341-6.385 15.226-13.17 17.95-1.711.688-3.85.89-5.548 1.596-6.486 2.697-8.971 9.542-14.918 12.632-5.451 2.834-12.517 2.752-18.416 1.519-1.939-.405-5.652-2.081-6.938-2.155-2.986-.172-7.245 2.326-10.775 2.268-8.503-.138-11.272-4.122-17.214-8.547-4.695-3.497-11.074-1.833-15.184-5.088-1.55-1.227-3.369-5.759-5.152-7.484-2.899-2.805-7.205-2.511-10.485-5.076-4.184-3.271-4.549-7.691-2.234-12.324.367-.733 1.507-.775 1.54-1.977.09-3.208-4.052-8.204 2.176-10.395.363 4.002.325 9.838 3.299 12.771 4.166 4.108 7.505.326 11.37 1.899 3.506 1.428 3.223 6.967 8.59 7.73 6.783.964 8.495-5.345 14.648-3.926 3.492.805 4.778 7.99 8.662 6.956 3.37-.898 1.073-5.251.889-7.324-.448-5.052 1.865-9.848 6.855-11.502 6.121-2.029 11.569 2.219 17.518 1.443 2.22-2.531.36-3.654-.158-5.997-.492-2.229-1.642-7.661.913-8.835 4.213-.552 5.062 4.625 7.699 7.111 2.786 2.627 5.002 2.956 8.74 2.723 12.195-.761 16.019-11.974 15.049-22.686-.222-2.456-2.424-6.703-.49-8.162 4.63-3.494 13.919-3.199 14.307 4.075.147 2.748-2.051 3.692-2.074 6.363M3.555 132.756c-5.561 4.857-11.716 9.146-18.158 12.746-5.727-5.896-.819-14.806-5.386-21.174-1.028-1.432-2.877-2.385-3.548-4.104-1.109-2.844-.455-5.981-.809-8.884-1.567-12.824-16.663-13.361-24.676-20.222-2.231-1.91-5.957-5.495-2.287-7.868 3.834-2.48 7.68 1.396 11.454 1.762 7.183.695 11.581-5.238 17.614-7.388 6.72-2.396 14.768-.828 19.588-7.452 1.855-2.548 1.987-5.832 4.859-7.385 2.836-1.532 6.576-.77 9.755-1.47 5.086-1.118 7.27-3.394 7.624-8.714.246-3.701-1.869-7.36-.788-10.981.657-2.204 5.148-7.059 7.624-7.598.626.147 4.065 7.929 4.267 9.016.493 2.639-.145 5.654.253 8.42 1.224 8.523 6.592 9.388 13.637 6.001-3.726 29.137-19.068 56.115-41.023 75.295m-107.44 29.801c-34.67-5.047-65.126-24.926-85.188-53.315 3.765-1.714 7.269-3.089 10.431-5.879 2.448-2.161 5.439-6.924 7.961-8.366 1.965-1.123 5.145-1.187 7.453-2.241 2.351-1.074 4.259-3.143 6.279-4.683 3.514 8.511 5.62 21.187 15.326 24.73 4.299 1.569 16.419 2.524 18.587 5.902 2.253 3.508-.839 10.052 3.622 15.254 3.181 3.709 12.011 4.608 13.265 8.674.351 1.138.666 4.938.757 6.386.292 4.664-.757 9.099 1.507 13.538m53.573-188.258V-8.61c0 .961-1.797 5.071-2.543 5.988C-57.331 2.881-64.529.696-70.489 2.11c-14.22 3.376-20.139 15.374-21.141 29.084-1.064 14.568 2.731 24.069 15.964 30.446 6.567 3.166 16.27 8.013 23.59 8.081 9.799.091 14.593-8.244 21.989-11.677 8.015-3.721 17.093-1.689 22.731-10.432 2.154-3.341 2.079-7.587 4.214-10.582 4.283-6.01 14.288-7.422 18.555-15.118C21.255 11.378 11.44 3.356 5.547-3.757c-5.762-6.954-4.132-14.265-8.313-21.278-4.597-7.711-14.113-9.794-18.461-17.763l20.219-14.485c1.659-.29 12.029 10.324 13.711 12.187 23.185 25.677 34.989 58.88 32.936 93.648l-.104.676c-3.058.408-5.091 3.243-8.094 3.13V41.899c0-.414-2.545-6.831-2.97-7.744-3.83-8.225-8.017-9.608-15.127-3.72-4.303 3.564-7.971 8.124-7.97 14.017.001 2.323 2.254 8.503.265 9.91-1.271.899-7.677.604-10.038 1.187-8.451 2.087-6.986 9.491-11.952 12.011-4.151 2.106-9.584 1.721-14.084 3.278-5.141 1.779-9.561 7.495-14.852 6.979-5.749-.561-9.18-4.674-15.361-.968-8.68 5.205-5.537 14.423 1.03 19.885 5.274 4.387 11.437 5.801 16.924 9.096 7.853 4.715 4.038 8.751 6.002 15.937 1.352 4.949 5.328 5.358 5.883 10.953.356 3.586-.428 6.877.661 10.563.661 2.238 2.316 3.923 3.187 6.019-9.656 5.168-20.587 9.575-31.287 12.088-8.188 1.924-29.265 4.973-36.673 2.28-2.49-.906-7.645-3.208-8.501-5.785-1.235-3.718-.119-5.779-.294-8.843-.316-5.525-.953-11.302-5.7-14.754-3.561-2.59-11.039-3.358-11.446-8.189-.4-4.751 1.266-7.144-2.065-11.974-4.881-7.077-19.959-4.957-25.184-9.508-1.441-1.255-4.619-8.116-5.576-10.24-.666-1.479-4.644-11.437-4.538-12.089 2.082-3.468 4.45-7.803 4.935-11.859.368-3.086-.979-9.276-.477-11.078.12-.431 1.519-.933 2.073-1.607 4.891-5.947 6.526-14.567 2.442-21.373-.676-1.126-2.594-2.558-2.886-3.79-.345-1.456.795-5.291.298-7.907-.338-1.773-1.799-4.363-3.452-5.23l.013-.482c6.061-5.977 12.745-11.59 20.563-15.16 10.411-4.755 14.669-1.903 25.109-2.442C-82.226.255-64.623-10.381-50.312-25.701m67.167-24.821c-3.871-4.032-8.188-7.695-12.568-11.148 8.453-7.475 16.811-15.239 23.957-23.993 8.425-10.324 9.021-16.48 3.975-28.948-10.983-27.142-39.431-55.955-60.415-76.062-1.951-1.87-8.27-9.681-10.714-9.92-2.56-.251-4.331 3.086-2.449 4.976 21.562 23.45 47.294 45.698 62.739 73.988 7.109 13.019 11.245 20.178 1.016 32.669C6.921-70.061-16.489-51.931-38.238-40.922c-3.658 1.851-8.595 3.186-11.945 5.401-3.446 2.28-7.433 8.017-10.837 11.103-13.037 11.817-27.817 18.577-45.647 19.144-8.327.266-12.757-2.067-21.328 1.123-9.698 3.609-19.379 12.271-26.237 19.812-5.283-1.19-11.063-.695-15.216 3.01-2.29-4.018-5.281-8.767-10.453-8.662 3.819-11.379 7.666-25.498-.511-35.966-1.833-2.346-8.299-6.012-8.564-6.482-.209-.371-.486-3.371-1.042-4.829-.977-2.562-2.783-4.326-4.199-6.561 3.083-3.97 8.141-7.749 7.097-13.427-6.172-2.351-8.285 7.417-13.692 8.596-.946-4.135-6.916-9.039-10.973-9.21-.574-.024-1.65.564-1.74.501-.131-.092-.98-2.062-1.595-2.758-3.897-4.408-9.302-6.591-14.793-3.547-.695-.429-5.322-11.921-5.832-13.581-3.542-11.539-3.615-21.474-13.013-30.863-1.174-1.174-5.188-4.62-5.662-1.492-.206 1.363 5.071 10.498 6.032 12.856 2.706 6.642 3.782 13.741 6.007 20.524 1.981 6.04 4.83 11.819 7.384 17.623.198 1.341-2.538.637-3.715.882-5.437 1.13-10.471 9.819-11.031 14.984l-.304 5.301c-13.785-12.923-30.601-29.27-37.385-47.31-1.412-3.753-1.878-7.5-3.048-11.237-2.135-6.811-7.806-15.891-1.172-22.332 6.939-6.736 29.222-6.414 38.285-5.073 10.095 1.494 20.461 5.012 28.997 10.526.302 3.874-.138 7.88.217 11.732.323 3.509 4.165 24.219 5.687 25.987 1.477 1.713 4.216 1.075 4.795-.923.608-2.102-3.498-19.255-3.92-23.42-.989-9.783-1.385-22.851 5.336-30.757 1.678-1.974 6.557-4.793 7.125-6.65.816-2.668.027-7.882.233-10.991 1.085-16.317 8.169-17.96 12.984-30.383 1.652-4.263 6.475-19.408 3.219-22.816-6.925-2.716-6.225 8.979-7.154 13.268-2.678 12.359-11.646 18.465-14.443 30.456-1.342 5.755-1.023 12.162-1.339 18.047-.382 1.243-2.028 1.287-2.987 2.116-4.589 3.969-7.709 11.189-8.657 17.112-15.45-9.189-34.4-12.131-52.188-10.481-16.41 1.522-30.9 8.68-25.112 27.84 1.702 5.636 4.462 13.313 6.518 18.99 6.482 17.902 22.437 35.166 36.087 48.096 3.457 3.275 7.24 3.888 5.91 9.468-1.27 5.328-6.135 7.151-7.46 11.927-.581 2.095-.5 3.714-.547 5.828-7.503 1.359-8.855 7.915-8.039 14.547.943 7.67 3.761 15.721 4.362 23.563-6.391 3.302-8.411 7.483-5.954 14.502-6.252-.073-10.914 6.633-10.739 12.519.042 1.382.664 2.641.571 4.057-.113 1.733-1.63 3.637-1.943 5.754-1.002 6.785 2.711 13.833 8.711 17.042 2.198 1.176 5.981 1.793 7.445 3.27 2.569 2.592 2.758 6.175 7.01 8.809 4.31 2.669 8.713 1.651 12.043 3.259 1.554.751 3.441 3.455 5.006 4.688 6.98 5.499 16.22 7.218 24.789 4.977 1.25-.327 2.424-1.541 3.392-1.495 1.172.056 3.501 1.345 4.934 1.668 3.833.863 7.791 1.668 11.736 1.498 17.523 26.595 42.989 46.097 73.473 55.637 73.96 23.145 156.084-20.838 173.227-97.173 9.386-41.794-3.479-88.369-33.103-119.224",
    clipPath: "url(#b)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 832.594 647.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.752 4.07-13.793-60.186 5.21 6.772c7.443 8.996 8.832 20.152 12.905 30.461C-6.841-12.33-3.11-6.286 0 0m-26.743-65.599c-3.469-4.323-19.123-24.323-23.549-24.719-1.163-.105-2.668 1.187-2.783 2.333-.275 2.769 6.265 7.979 8.165 10.197 2.077 2.423 5.119 5.902 6.859 8.446 3.125 4.569 5.943 23.883 7.589 30.676 3.672 15.163 8.496 30.042 10.393 45.591-12.36 6.682-22.01 17.716-35.803 21.632-.825-.066-1.095-4.574-1.418-5.702-3.601-12.566-16.502-32.306-27.903-38.933-3.08-1.79-7.295-4.181-10.66-2.214-1.679 1.77 7.813 7.239 9.126 8.34 11.868 9.947 19.233 25.485 24.993 39.541-3.586-1.426-16.228 2.23-9.031 6.23 5.013 2.785 19.165-1.131 24.33-3.427 10.087-4.482 18.044-12.998 27.726-18.191 7.299-3.916 15.186-6.326 23.146-8.49 1.734-.031 3.444 5.094 7.439 3.887 2.065-.624 1.846-2.817 1.095-4.459-1.039-2.272-6.13-7.561-7.985-10.377C-4.093-19.02-5.072-33.28-12.654-46.78c-3.885-6.916-9.177-12.699-14.089-18.819",
    clipPath: "url(#c)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 792.72 793.555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.507 1.063 2.993 3.061 4.462 4.068 4.215 2.891 22.113 12.289 26.554 12.666 3.107.264 4.175-1.611 1.617-3.704-2.159-1.767-8.857-4.25-11.871-5.987C13.152 2.656 3.357-4.018-3.302-9.708c-2.204-1.882-6.419-8.185-9.235-6.144-3.41 2.471 2.48 6.95 3.78 9.048 1.234 1.993 1.86 6.18 2.116 8.598.315 2.976-1.147 15.81 4.476 13.135C-1.016 14.383 0 11.544 0 10.459Z",
    clipPath: "url(#d)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 618.575 696.954)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.337 1.362 4.214.086 4.482-1.688C1.508-19.267-.81-37.68 8.466-53.819c-.484-6.201-5.8.716-7.279 2.958-6.621 10.043-6.302 28.93-4.309 40.467C-2.849-8.814-.747-.76 0 0",
    clipPath: "url(#e)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 581.322 746.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.878.032-1.861-.154-2.708.099-2.42.721-4.955 13.565-6.713 16.754-2.811 5.099-7.419 8.102-9.705 14.275-1.249 3.371-3.92 15.936 2.048 15.802 2.843-.064 2.504-7.889 3.019-10.224 1.807-8.184 7.6-11.272 10.906-18.176C-2.654 17.488 0 10.492 0 9.949Z",
    clipPath: "url(#f)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 611.772 907.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.803.667 2.961-3.949.379-6.015-3.38-2.704-14.119-4.812-17.978-3.184-2.9 1.223-1.571 4.264.861 4.996 2.324.7 6.005.363 9.031 1.172C-5.254-2.375-2.073-.288 0 0",
    clipPath: "url(#g)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 655.142 805.257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.258-3.233-.88-5.366-4.584-4.839-5.279.75-7.929 2.738-14.42 1.93-4.226-.526-11.036-6.295-15.066-2.34C-38.977-.434-30.351.146-27.804.789c7.162 1.809 13.961 3.558 21.419 1.753C-5.451 2.316-.457.453 0 0",
    clipPath: "url(#h)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 534.715 593.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.379.315 4.813.496 5.51-.908 1.612-3.244-3.608-4.701-3.838-6.904-.19-1.823 1.769-3.926 2.022-5.635.392-2.643-.877-8.976-4.323-8.883-3.65.099-1.588 5.646-1.781 7.337-.171 1.486-1.632 2.86-1.918 4.248C-5.05-7.239-4.119-.941 0 0",
    clipPath: "url(#i)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 588.445 587.577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.69-1.525.863-6.506-.834-7.067-5.218-1.727-3.412 4.126-5.26 6.208-.908 1.023-5.15 1.496-1.829 4.45 3.176 2.825 18.061 2.358 19.095-.863C12.936-2.767 1.085.923 0 0",
    clipPath: "url(#j)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 510.416 609.886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.265-5.695-8.269-3.514-11.191-1.76-6.264 3.757-5.681 5.405-14.195 7.743-.512.14-5.342.397-4.097 1.761 3.266 1.158 7.354 1.927 10.846 1.416 4.459-.653 6.606-3.63 10.239-5.576C-5.614 2.093-2.715 1.534 0 0",
    clipPath: "url(#k)",
    style: {
      fill: "#002566",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 594.623 546.75)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlas);
export default __webpack_public_path__ + "static/media/ATLAS.ab470dd453a1f9a39b8c1ea2cd2164b7.svg";
export { ForwardRef as ReactComponent };